"use client";

import { MonitorPlay, Trophy, UserCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Doctor of Physical Therapy",
  description: "Jessica Gade, DPT, CSMT, applies her clinical background to provide therapeutic bodywork that goes beyond a standard massage.",
  icon: UserCheck
}, {
  title: "Anatomy-Based",
  description: "Every session is informed by a precise understanding of canine musculoskeletal systems, targeting the root of mobility issues.",
  icon: MonitorPlay
}, {
  title: "Evidence-Led",
  description: "Our protocols are based on proven physiological principles, designed to support peak performance and comfort for aging or active dogs.",
  icon: Trophy
}];
export default function SpaceOpportunities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222323" id="the-dpt-difference" className="py-24 bg-background text-foreground dark relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className={`text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            The DPT Difference
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-sans leading-[1.8]">
            Discover the clinical expertise and anatomy-driven focus that makes our canine bodywork a premium choice for Durango's active dogs.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full bg-card border-none border-l-4 border-primary shadow-md transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-2 group overflow-hidden relative">
                {}
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
                <CardHeader className="pb-4 relative z-10">
                  <div className="w-16 h-16 rounded-2xl bg-secondary flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 ease-out shadow-sm">
                    <feature.icon className="w-8 h-8 text-primary" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-2xl font-bold font-default text-foreground tracking-tight">
                    {feature.title}
                  </CardTitle>
                  <Separator className="w-12 h-[2px] bg-primary mt-5 transition-all duration-300 group-hover:w-16" />
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground text-base leading-[1.8] font-sans">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}